// Guardar un archivo desde el navegador. Un solo sitio, porque el baile
// del <a> temporal es facil de escribir a medias: sin `revokeObjectURL`
// el blob se queda en memoria hasta recargar la pagina, y con varias
// exportaciones seguidas de 20 000 renglones eso se nota.
export function guardarArchivo(blob, nombreArchivo) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombreArchivo;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // SE SUELTA DESPUÉS, NO EN EL MISMO INSTANTE. La descarga arranca
  // cuando el navegador ya salió de este clic; si el enlace del blob se
  // suelta aquí mismo, a veces la descarga lo busca y ya no está, y queda
  // un «net::ERR_FAILED» en la consola (la hoja de etiquetas en PDF,
  // LISTO-PARA-PILOTO b, P8, 29 sep 2026). Un minuto sobra para empezar a
  // bajar y el blob no se queda en memoria hasta recargar.
  setTimeout(() => URL.revokeObjectURL(url), SOLTAR_BLOB_MS);
}

export const SOLTAR_BLOB_MS = 60_000;
